const Title = () => {
  return (
    <>
      <h1>Contact Management System Application</h1>
    </>
  );
};

export default Title;
